import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";

export const longDate = (date) => format(parseISO(date), "EEEE d MMMM yyyy", { locale: it });

const detailLines = ({ vehicle, trailer, notes }) => {
  const lines = [];
  if (vehicle) lines.push(`Automezzo: ${vehicle}${trailer ? " + rimorchio" : ""}`);
  else if (trailer) lines.push("Rimorchio: sì");
  if (notes?.trim()) lines.push(`Note: ${notes.trim()}`);
  return lines;
};

export const taskShareText = (task, employee) =>
  [
    `*${task.title.trim()}*`,
    `Dipendente: ${employee?.name || "da assegnare"}`,
    `Giorno: ${task.date ? longDate(task.date) : "da definire"}`,
    ...detailLines(task),
  ].join("\n");

export const dayShareText = (employee, date, tasks) => {
  // Same order as shown in the planner cell
  const blocks = tasks.map((t, i) => {
    const head = `${i + 1}. *${t.title.trim()}*${t.completed ? " (completata)" : ""}`;
    const lines = [t.time && `Orario: ${t.time}`, ...detailLines(t)].filter(Boolean);
    return [head, ...lines.map((l) => `   ${l}`)].join("\n");
  });
  return [`*${employee.name} – ${longDate(date)}*`, `${tasks.length} attività`, "", blocks.join("\n\n")].join("\n");
};

export const whatsappUrl = (text) => `https://wa.me/?text=${encodeURIComponent(text)}`;

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  }
};
